import { DEFAULT_CRM_TOKEN, portalHomeUrl } from './constants';
const privateSubmissionBaseUrl = 'https://agency.comcate.com/private-submission';
const logoutRedirectUrl = encodeURIComponent(portalHomeUrl);
export const submitRequestUrl = `${privateSubmissionBaseUrl}/create?crm_token=${DEFAULT_CRM_TOKEN}&logout_redirect_url=${logoutRedirectUrl}`;
export const loginToAccountUrl = `${privateSubmissionBaseUrl}/listing?crm_token=${DEFAULT_CRM_TOKEN}&auth_enabled=true&logout_redirect_url=${logoutRedirectUrl}`;
